import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const SessionsService = {
    list: async () => axios.get(API_URL + "/sessions/list").then(({ data: {data} }) => data).catch((err) => { throw err }),

    destroySession: async (data) => axios.post(API_URL + "/sessions/destroy", data).catch((err) => { throw err }),
};

export default SessionsService;